import { ChevronDown } from "lucide-react";
import type { SelectHTMLAttributes } from "react";
import { useId } from "react";
import { FieldWrapper } from "./FieldWrapper";

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  helper?: string;
  error?: string;
  required?: boolean;
  options: SelectOption[];
  placeholder?: string;
}

export default function Select({
  label,
  helper,
  error,
  required,
  options,
  placeholder,
  className = "",
  id,
  ...rest
}: SelectProps) {
  const autoId = useId();
  const selectId = id ?? autoId;

  return (
    <FieldWrapper label={label} helper={helper} error={error} required={required} htmlFor={selectId}>
      <div className="relative">
        <select
          id={selectId}
          className={`h-[42px] w-full appearance-none rounded-lg border bg-white pr-10 pl-3.5 text-sm text-ink focus:outline-none focus:ring-2 ${
            error
              ? "border-danger focus:ring-danger/30"
              : "border-slate-300 focus:border-primary-500 focus:ring-primary-500/30"
          } ${className}`}
          aria-invalid={!!error}
          {...rest}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 flex h-5 w-5 items-center justify-center text-ink-muted">
          <ChevronDown className="h-4 w-4" />
        </span>
      </div>
    </FieldWrapper>
  );
}